module.exports = __webpack_public_path__ + "static/digital-1-b6d0e8fb598e6ef796fb9763f14224da.jpg";